import appConfig from './apiConfig';
import country from '../pages/country';

  //fetchUsersByCountryApi

  export const fetchCountCountryDataApi =()=>{

    const headers = Object.assign({'content-type':'application/json',
                                   'accept':'*/*'
                               });
    const request= new Request( appConfig.siteURL+'getUserCountByCountry', {
      method : "GET",
      headers : headers,
    });
    
    return fetch(request).then(response => {
        return  response.json().then(countryDataResponse => {
          return countryDataResponse;
        });
      }).catch(error => {
       return error;
     });
    }
  
//getUsersByCountryApi

export const getUsersByCountryApi =(country, from)=>{

  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'getUsersByCountry/'+ country+'/'+from, {
    method : "GET",
    headers : headers,
  });
  
  return fetch(request).then(response => {
      return  response.json().then(countryDataResponse => {
        return countryDataResponse;
      });
    }).catch(error => {
     return error;
   });
  }


//disableMemberApi
export const disableMemberApi =(id)=>{
let objLogin =  JSON.stringify(id);
const headers = Object.assign({'content-type':'application/json',
                                'accept':'*/*'
                            });
const request= new Request( appConfig.siteURL+'disabledUsers/', {
  method : "POST",
  headers : headers,
  body : objLogin
});

return fetch(request).then(response => {
    return  response.json().then(disableMemberResponse => {
      return disableMemberResponse;
    });
  }).catch(error => {
    return error;
  });
}

 //enableMemberApi
 export const enableMemberApi =(id)=>{
  let objLogin =  JSON.stringify(id);
  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'enabledUsers/', {
    method : "POST",
    headers : headers,
    body : objLogin
  });
  
  return fetch(request).then(response => {
      return  response.json().then(disableMemberResponse => {
        return disableMemberResponse;
      });
    }).catch(error => {
     return error;
   });
  }

  //getAllDemographicsDataByUserApi
  export const getAllDemographicsDataByUserApi =(catid, uid)=>{

    const headers = Object.assign({'content-type':'application/json',
                                   'accept':'*/*'
                               });
    const request= new Request( appConfig.siteURL+'getAllDemographicsDataByUser/'+ catid+'/'+uid, {
      method : "GET",
      headers : headers,
    });
    
    return fetch(request).then(response => {
        return  response.json().then(countryDataResponse => {
          return countryDataResponse;
        });
      }).catch(error => {
       return error;
     });
    }


// WEBPACK FOOTER //
// ./src/api/country.js